import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const NEW_PROJECT = 'new project'
export const ALL_SURVEYS = 'all surveys'
export const CHOOSE_TEMPLATES = 'choose templates'
export const SEARCH_TEMPLATE = 'search template'

export default {
  [PORTUGUESE]: {
    [NEW_PROJECT]: 'Novo Projeto',
    [ALL_SURVEYS]: 'Todas as Pesquisas',
    [CHOOSE_TEMPLATES]:
      'Escolha o seu modelo. Clique em cada um para saber mais sobre eles.',
    [SEARCH_TEMPLATE]: 'Pesquisar Modelo',
  },

  [ENGLISH]: {
    [NEW_PROJECT]: 'New Project',
    [ALL_SURVEYS]: 'All Surveys',
    [CHOOSE_TEMPLATES]:
      'Choose your template. Click on each one to learn more about them.',
    [SEARCH_TEMPLATE]: 'Search Template',
  },

  [SPANISH]: {
    [NEW_PROJECT]: 'Nuevo Proyecto',
    [ALL_SURVEYS]: 'Todas las Encuestas',
    [CHOOSE_TEMPLATES]:
      'Elige tu modelo. Haz clic en cada uno para conocer más sobre ellos.',
    [SEARCH_TEMPLATE]: 'Buscar modelo',
  },
}
